export default class Gallery {
	constructor(root) {
		this.root = root;
		this.items = root?.querySelectorAll('.gallery-item');
		this.view = root?.querySelector('.gallery-view picture');

		this.fancyboxAnchors = Array.from(this.root.querySelectorAll('a[data-fancybox="gallery"]'));

		this.activeIndex = 0;

		this.select(this.items[0], 0);

		this.items.forEach((item, index) => {
			item.addEventListener('click', () => {
				this.select(item, index);
			});
		});

		this.view.addEventListener('click', () => {
			const currentAnchor = this.fancyboxAnchors[this.activeIndex];
			if (currentAnchor) currentAnchor.click();
		});
	}

	deselect(item) {
		item?.classList.remove('active');
	}

	select(item, index) {
		const pictureEl = item?.querySelector('picture');
		const main = this.view;

		main.innerHTML = pictureEl.innerHTML;

		this.items.forEach((i) => this.deselect(i));
		item?.classList.add('active');

		this.activeIndex = index;
	}
}
